import { render } from "./CosmicBackground.vue?vue&type=template&id=bc0fdfbe&scoped=true"
import script from "./CosmicBackground.vue?vue&type=script&lang=js"
export * from "./CosmicBackground.vue?vue&type=script&lang=js"

import "./CosmicBackground.vue?vue&type=style&index=0&id=bc0fdfbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0fdfbe"]])

export default __exports__